import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CompetitionRequirementComponent = (props) => {
    const [reqList, setReqList] = useState([]);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        const getReq = async () => {
            await competitionService.getCompetitionGeneralReq(props?.competition?.id)
                .then((_reqList) => {
                    // console.log("reqList: ", _reqList);
                    setReqList(_reqList);
                })
                .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getReq();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService]);

    return (
        <>
            <Toast ref={toast} />

            <div className='col-12 mt-3 mb-3'>
                <h5>{translatedMessage('competition.requirements.general')}</h5>
                {reqList && reqList.length > 0 &&
                    reqList.map((req, index) => (
                        <div key={index} className='flex align-items-center mb-3'>
                            <FontAwesomeIcon icon='fa-solid fa-square-check' size='xl' className="mr-2 icon-disabled"/>
                            <div>{req.name}</div>
                        </div>
                    )
                    )}
            </div>
        </>
    );
};

export default CompetitionRequirementComponent;
